import type { PropType } from 'vue'

export const basicProps = {
  formData: {
    type: Object as PropType<Recordable>,
    default: () => ({})
  },
  modelValue: {
    type: [String, Number, Array] as any,
    default: ''
  },
  renderConfig: {
    type: Object as PropType<Recordable>,
    default: () => ({})
  },
  data: {
    type: Object as PropType<Recordable>,
    default: () => ({})
  },
  isTxt: {
    type: Boolean,
    default: false
  },
  // 清空所有空格
  trim: {
    type: Boolean,
    default: false
  },
  positions: {
    type: Array as PropType<Recordable[]>,
    default: () => []
  },
  shopOrderId: {
    type: String,
    default: ''
  },

  subFieldFormData: {
    type: Object as PropType<Recordable>,
    default: () => ({})
  },

  isIncludeChild: Boolean,
  maxLength: String
}
